import { Box, TablePagination, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import LayoutTable from "./layout/Table";
import Search from "../../../shared/components/Search";
import { FilterIconSvg } from "../../../assets/icons/FilterIconSvg";
import userImage from "../../../assets/icons/studioIcons/userImg.svg";
import { ButtonPrimary } from "../../../shared/components/button/Buttons";
import { useGlobalContext } from "../../../App";

type Props = {};

export interface ActionMenuProps {
  title: string;
  action: () => void;
  actionTitle: string;
}

let faqsCardData = [
  {
    question: "What exactly does UI Wiki do?",
    answer:
      "We design clean, user-friendly interfaces for web and mobile products—from wireframes and prototypes to full UI systems",
  },
  {
    question: "How fast can i get my design?",
    answer:
      "UI Wiki is designed for both professional UI/UX designers and non-designers. Designers can quickly find and implement high-quality components, speeding up their workflow. Non-designers can access ready-made design elements, making it easy to incorporate professional designs into their projects.",
  },
  {
    question: "Can i request revisions?",
    answer:
      "Definitely. UI Wiki is designed to be user-friendly, with pre-made components that are easy to implement. Whether you’re a seasoned designer or new to the world of design, you’ll find it simple to add professional-quality elements to your projects.",
  },
  {
    question: "Do you offer development too?",
    answer:
      "Definitely. UI Wiki is designed to be user-friendly, with pre-made components that are easy to implement. Whether you’re a seasoned designer or new to the world of design, you’ll find it simple to add professional-quality elements to your projects.",
  },
  {
    question: "Is there a minimum commitment?",
    answer:
      "Yes, UI Wiki components are built for Figma, so you’ll need a Figma account to use and edit the components. If you don’t have an account, you can create one for free on Figma’s website.",
  },
];

const tableRef = React.createRef<any>();

const FaqsList = (props: Props) => {
  const { studioContentData } = useGlobalContext();

  const columnItems = [
    { id: "Question", label: "Question" },
    { id: "Answer", label: "Answer" },
  ];

  // TabPanel handling states and functions
  const [value, setValue] = useState(0);

  // current page and rows per page handling states and functions
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [search, setSearch] = useState("");
  const [faqsLoading, setFaqsLoading] = useState(false);
  const [faqsList, setFaqsList] = useState<any>(faqsCardData || []);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    // api call here
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    tableRef.current && tableRef.current.scrollIntoView();
    setRowsPerPage(+event.target.value);
    setPage(0);
    // api call here
  };

  useEffect(() => {}, [faqsList]);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          paddingTop: "32px",
          paddingBottom: "12px",
        }}
      >
        <Box
          sx={{
            position: "fixed",
            top: "15px",
            right: "98px",
            zIndex: 10000,
          }}
          display="flex"
          alignItems="center"
          justifySelf="flex-end"
        >
          <ButtonPrimary
            sx={{
              height: "45px !important",
              border: "14px !important",
              // width: "112px",
              width: "auto",
            }}
            onClick={() => {}}
            LabelStyle={{ fontSize: "18px !important" }}
            label="Add Faq(s)"
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            width: "85%",
            mb: "21px",
            gap: "12px",
          }}
        >
          <Box
            // onKeyDown={handleKeyDown}
            sx={{ display: "flex", height: "52px" }}
          >
            <Search
              searchFormStyles={{
                minHeight: "22px",
              }}
              style={{
                minHeight: "52px",
                color: "white",
              }}
              icon={true}
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Box>

          <Box
            onClick={() => {}}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "52px",
              height: "52px",
              borderRadius: "14px",
              bgcolor: "#141414",
              boxShadow: "inset 0px 0px 0px 2px #3D3D3D",
              cursor: "pointer",
            }}
          >
            <FilterIconSvg />
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            overflowY: "scroll",
            // overflowX: "scroll",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            scrollbarWidth: "none",
          }}
        >
          <TabPanel value={value} index={0}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                // overflowX: "scroll",
              }}
            >
              <Box
                sx={{
                  width: "85%",
                  //   paddingBottom: activeSelectedMenu ? "70px" : "0px",
                  height: "auto",
                  // overflowX: "scroll",
                }}
              >
                <LayoutTable
                  loading={faqsLoading}
                  // rows={faqsList}
                  rows={faqsList.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )}
                  columns={columnItems}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <TablePagination
                    labelRowsPerPage="Showing"
                    SelectProps={{
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      style: {
                        fontWeight: "700",
                      },
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            backgroundColor: "#3D3D3D",
                            "& .MuiMenuItem-root": {
                              color: "#ffff",
                              "&:hover": {
                                backgroundColor: "#555555",
                              },
                            },
                          },
                        },
                      },
                    }}
                    sx={{
                      "& .MuiTablePagination-selectLabel": {
                        fontWeight: "700",
                        color: "rgba(255, 255, 255, 0.24)",
                        marginRight: "5px",
                      },
                      "& .MuiTablePagination-displayedRows": {
                        color: "rgba(255, 255, 255, 0.24)",
                        fontWeight: "600",
                      },
                      "& .MuiButtonBase-root": {
                        boxShadow: "inset 0px 0px 0px 2px #3D3D3D",
                        cursor: "pointer !important",
                      },
                      "& .MuiSvgIcon-root": {
                        color: "white",
                      },
                      "& .MuiTablePagination-actions": {
                        display: "flex",
                        gap: "12px !important",
                        flex: 1,
                        justifyContent: "flex-end",
                      },
                      "&.MuiTablePagination-root": {
                        width: "100%",
                        flex: 1,
                        display: "flex",
                        justifyContent: "space-between",
                      },
                      "& .MuiTablePagination-spacer": {
                        flex: 0,
                        display: "none",
                      },
                      "& .MuiTablePagination-toolbar": {
                        flex: 1,
                        display: "flex",
                        paddingLeft: 0,
                      },
                      "& .MuiTablePagination-select": {
                        backgroundColor: "rgba(255, 255, 255, 0.08)",
                        borderRadius: "4px",
                        padding: "6px 12px",
                      },
                      "& .MuiInputBase-input": {
                        color: "#ffff",
                      },
                      // To hide the rows per page dropdown
                      "& .MuiInputBase-root": {
                        // display: "none",
                      },
                    }}
                    rowsPerPageOptions={[25, 50, 100]}
                    component="div"
                    count={faqsList?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Box>
              </Box>
            </Box>
          </TabPanel>
        </Box>
      </Box>
    </>
  );
};

export default FaqsList;

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      sx={{ width: "100%" }}
      className="HideScrollbar"
      // sx={{ maxHeight: SECTION_MIN_HEIGHT }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ flex: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}
